import React from 'react';

import { Helpers } from '../../../../core/src/helpers';
import ProductDetailRow from '../../../../product/components/product-detail-row';
import KspList from '../../../../product/components/ksp-list';
import ProductPrice from '../../../../product/components/product-price';
import InventoryMessage from '../../../../product/components/inventory-message';
import LoyaltyBadge from '../../../../product/components/loyalty-badge';
import PDPOffersList from '../../pdp-offers-list';
import PDPBadge from '../../pdp-badge';
import PDPMobileImage from '../../pdp-mobile-image';
import GiftCard from '../../../../gift-card';
import  ProductJsonLd  from '../../../../product/components/product-json-ld';
import { SwatchGroup } from '../../variant-swatch/swatch-group';
import PDPUpsell from '../../pdp-upsell';
import BundleModule from '../../bundle/bundle-module';
import SpecsLink from '../../specs-link';
import CarePackModule from '../../bundle/carepack-module';
import ExternalSkuUpsell from '../../pdp-ext-upsell';
import '../../../css/product-detail.less';

const SHIPPING_TEXT_MAP = {
    'BTO': 'Ships within 14 business days',
    'STO': 'Ships within 1 business day'
}

export const ProductDetail = ({
        product, purchaseButton, colorGroup, selectedColor, handleTabChange,
        changeColor, onAddOnChange, carePacks, isMobileView, totalPrice, showCarepackModule
}) => {
    const { prdClass="",  attributes={}, eol, pdpConfig={}, ksps, offers=[] } = product;
    const { carepacktype, loyalty_multiplier } = attributes;
    const { pdpDetails={}, pdpCarepackModule } = pdpConfig;
    const { productBadge, disableBadge, forceOOS, hideShipMessage } = pdpDetails;
    const isGiftCard = Helpers.isGiftCard(product);
    const offersMsg = !isGiftCard && product.offers && product.offers.length > 1 ? 'Special offers: ' : '';
    const shippingText = !eol && SHIPPING_TEXT_MAP[prdClass];
    const isECarePack = (carepacktype || "").toLowerCase() === 'electronic';
    const changeTab = (tabName) => () => handleTabChange(tabName);
    const hasBundle = !eol && !!product.bundle;
    const hasUpsell = !eol && !!(product.upsell && product.upsell.productsList && product.upsell.productsList.filter((prod) => prod.sku && prod.sku !== product.sku).length > 0);
    const hasReplacement = !!pdpDetails.replacementProduct;

    //CTO color options have the same hex value, use displayName instead
    const selectedProp = "displayName";
    const eCarePackMsg = isECarePack ?
        (<div className="ecarepack-msg">
            HP Care Packs are delivered electronically. <a className="link" href={`${process.env.BASENAME}/cv/carepackfaq`} target="_blank">See details.</a>
		</div>) : null;
    const productDetailCLass = (!isMobileView ? "product-detail" : "pdp-mobile-content") +
                                (hasBundle || showCarepackModule ? " with-bundle" : "");
    return(
        <div className={productDetailCLass}>
            <h1 tabIndex={0} aria-label={product.name}>{product.name}</h1>
            { !isMobileView && <ProductDetailRow 
                                    product={product} 
                                    pdp={true}
                                    displayAvgRating={true}
                                    displaySkuID={false}
                                    changeTab={changeTab('Reviews')}
                                />}
            <ProductJsonLd product={product}/>
            {!eol && product.offers && product.offers.length > 0 && <PDPOffersList product={product} changeTab={changeTab('Special Offers')} message={offersMsg}/>}
            {isMobileView && <PDPMobileImage 
                                defaultImages={product.defaultImages}
                                selectedColor={product.selectedColor}
                                sku={product.sku} 
                                images={product.images}/>}
            {
                isMobileView &&
                <div className='prd-hdr-2'>
                    { attributes.hasOwnProperty("energyeffcomp") &&
                        <div className="energy-star">ENERGY STAR</div>
                    }
                    {
                        !isGiftCard && <div className='product-sku'>Product #{product.sku}</div>
                    }
                </div>
            }
            { hasUpsell && <PDPUpsell product={product} withMetrics={true} /> }
            <GiftCard product={product}>
            {
                props => {
                    const { giftCardForm, purchaseOptions, validateForm } = props;
                    const { itemId:variantId } = purchaseOptions;
                    return (
                        <React.Fragment>
                            {giftCardForm}
                            {(!pdpDetails.disableKsps && !isMobileView)  ? <KspList ksps={product.ksps} limit={6}/> : null }
                            {(!isGiftCard && !isMobileView) ? <SpecsLink product={product} changeTab={changeTab} /> : null}
                            {	hasBundle ? 
                                <BundleModule 
                                    productSku={product.sku} 
                                    productsList={product.bundle.productsList} 
                                    metaData={product.bundle.metaData} 
                                    onChange={onAddOnChange}/> 
                                    : showCarepackModule && 
                                        <CarePackModule 
                                            product={product} 
                                            carePacks={carePacks} 
                                            onChange={onAddOnChange} 
                                            template='default'
                                            customConfig={pdpCarepackModule}
                                        />
							}	
                            { loyalty_multiplier && <LoyaltyBadge multiplier={loyalty_multiplier} /> }
							<ProductPrice
                                product={product}
                                variantId={variantId}
                                totalPrice={totalPrice}
                                className={totalPrice && 'total-price'}
                                dealPrice={true}
                            />
                            {(colorGroup.values.length > 0 && isMobileView) &&
                                <div className='color-picker'>
                                    <SwatchGroup
                                        swatchGroup={colorGroup}
                                        selectedSwatch={selectedColor}
                                        selectSwatch={changeColor}
                                        selectedProp={selectedProp}
                                    />
                                    <div className='color-picker-disclaimer'>Color Upgrade - *Cost may apply</div>
                                </div>
                            }
                            { isMobileView && <PDPBadge
                                                ksps={ksps}
                                                badgeSrc={productBadge}
                                                disableBadge={disableBadge}/> }
                            {
                                product.prdClass === 'EXT' ? <ExternalSkuUpsell category={attributes && attributes.pm_subcategory}>
                                    {
                                        ({upsell}) => {
                                            return <PDPUpsell product={upsell}/>
                                        }
                                    }
                                </ExternalSkuUpsell>:
                                (<InventoryMessage product={product} defaultText={shippingText}>
                                    {
                                        ({ shippingMsg, stockMsg, className="" }) => (
                                            <div className={`purchase-info${hasBundle ? ' purchase-with-bundle' : ''}${hasReplacement ? ' with-replacement' : ''} ${className.trim()}`}>
                                                {!forceOOS && <span className='stock-msg'>{stockMsg}</span>}
                                                {
                                                    purchaseButton && React.cloneElement(
                                                        purchaseButton, {
                                                            variant: purchaseOptions,
                                                            onClick: validateForm,
                                                            additionalParams: selectedColor.ctoConfig
                                                        }
                                                    )
                                                }
                                                {!forceOOS && !hideShipMessage && <span tabIndex={0} aria-label={shippingMsg} className={`shipping-msg${className}`}>{shippingMsg}</span>}
                                            </div>
                                        )
                                    }
                                    </InventoryMessage>)
                            }
                            {eCarePackMsg}
                        </React.Fragment>
                    );
                }
            }
            </GiftCard>
            <div className="pdp-line"></div>
            {(!isGiftCard && !isMobileView) ?
            <div className="pdp-sku-row">
                <span className="pdp-sku-title">Product #</span>
                <span className="pdp-sku">{product.sku}</span>
                {prdClass ==='EXT' && (
                    <React.Fragment>
                        <span className='pdp-upc-title'> UPC #</span>
                        <span className='pdp-upc'>{product.upc}</span>
                    </React.Fragment>)}
                <PDPBadge
                    ksps={ksps}
                    badgeSrc={productBadge}
                    disableBadge={disableBadge} />
            </div>
            : null}
            {(colorGroup.values.length && !isMobileView) > 0 &&
                <div className='color-picker'>
                    <SwatchGroup
                        swatchGroup={colorGroup}
                        selectedSwatch={selectedColor}
                        selectSwatch={changeColor}
                        selectedProp={selectedProp}
                    />
                    <div className='color-picker-disclaimer'>Color Upgrade - *Cost may apply</div>
                </div>
            }
        </div>
    )
}

ProductDetail.whyDidYouRender = true;